import React, { Component } from 'react';
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';

import ModalPatient from '../../offers/components/modalPatient';
import { Table } from 'react-bootstrap';
import Help from '../../generics/help';

var Config = require('../../../config');

class DirectReserves extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.search_nss = this.search_nss.bind(this);
        this.search_idee = this.search_idee.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.updateState = this.updateState.bind(this);
        this.loadDataPatient = this.loadDataPatient.bind(this);
        this.updateList = this.updateList.bind(this);
		this.loadComponent = this.loadComponent.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.getUnitComponent = this.getUnitComponent.bind(this);
		this.removeUnit = this.removeUnit.bind(this);
		this.onSave = this.onSave.bind(this);


        this.state = {
            search_type:"",
            nss:"",
            medical_attache:"",
            idee:"",
            options:[],
            isLoading:false,
            list:[],
            patient_name:"",
		    patient_lastname1:"",
			patient_lastname2:"",
			patient_sex:"",
			birthdate:"",
			idee:"",
            patient_id:"",
			unit_number:"",
			components:[],
			load:false,
			units:[]
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    search_nss(e){
		e.preventDefault();

		var valid = true;
		if(this.state.nss === ""){
			valid = false;
			document.getElementById('nss').classList.add('error');
		}

		this.setState({list:[]});

		if(valid){
			this.props.waiting.handleShow('Buscando...');
			fetch(Config.default.apiGateway.URL+'hl7_imss/search_person?nss='+this.state.nss+'&agregado_medico='+this.state.medical_attache+
                '&hf_id='+sessionStorage.getItem('health_facilities_id')+'&complete=true', {			
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res =>{
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					response.map((res)=>{
						res.check = false;
					});
					this.setState({list:response});

					this.modal_patient.handleShow();
				}
			})
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}

	}

	search_idee(e){
		e.preventDefault();

		var valid = true;
		if(this.state.idee === ""){
			valid = false;
			document.getElementById('idee').classList.add('error');
		}

		this.setState({list:[]})

		if(valid){
			this.props.waiting.handleShow('Buscando...');
			fetch(Config.default.apiGateway.URL+'hl7_imss/search_person?idee='+this.state.idee+'&hf_id='+
                sessionStorage.getItem('health_facilities_id')+'&complete=true', {
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res =>{
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					response.map((res)=>{
						res.check = false;
					});
					this.setState({list:response});

					this.modal_patient.handleShow();
				}
			})
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

    loadDataPatient(item){
		this.setState({
			patient_name: item.NOMBRE,
		    patient_lastname1: item.PRIMER_APELLIDO,
			patient_lastname2: item.SEGUNDO_APELLIDO,			
			patient_sex:item.SEXO === 'M' ? 'HOMBRE' : item.SEXO === 'F' ? 'MUJER' : '',			
			birthdate: moment(item.FECHA_NACIMIENTO.DateTime).format('DD/MM/YYYY'),			
			idee:item.IDEE
        });

		if(item.patient_id !== 0){
			this.setState({patient_id: item.patient_id});
		}		
	}

    updateList(list){
		this.setState({list:list});
	}

	handleSearch(query){
		this.setState({isLoading: true});
	    
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {

					response[i].names = response[i].lastname1 +' '+ 
										(response[i].lastname2 !== undefined &&  response[i].lastname2 !== null ?
											response[i].lastname2+' ' : '')+
										response[i].names +' '+
										(response[i].birthday !== null ?
											' - '+moment(response[i].birthday, 'DD/MM/YYYY').format('DD/MM/YYYY')
										: '')+
										(response[i].document_type_value !== null ?
											response[i].document_type_value !== ""?
												' - '+response[i].document_type_value+' '+
												response[i].document_number 	
											: ''
										: '')+
										(response[i].number !== "" && response[i].number !== null && response[i].number !== undefined?
											' - '+response[i].number : '')+										
										(response[i].social_number !== null && response[i].social_number !== "" && response[i].social_number !== undefined ?
											' - '+response[i].social_number : '');
					response[i].id = response[i].patient_id;
				};

				//error
				this.setState({
					isLoading: false,
			     	options: response,
			    });
			}
		})
	}

	updateState(e){
		
		if(e.length > 0){
			var val = e[0];
			this.setState({
				patient_id: val.patient_id,
				patient_name: val.names,
				patient_lastname1: val.lastname1,
				patient_lastname2: val.lastname2,				
				idee: val.idee,				
				birthdate: val.birthday !== null ? moment(val.birthday).format('DD/MM/YYYY') : ''
			});
		}
	}

	loadComponent(e){
		var error = '';

		if(e.length > 0){
			if(e[0].status !== 'DISPONIBLE'){
				error = 'La unidad no puede ser agregada debido a que se encuentra '+e[0].status+', intente seleccionar un componente distinto.';
			}
		}

		if(error === ''){
			let units = this.state.units;

			units.push(e[0]);

			this.setState({
				units: units,
				unit_number:"",
				components:[],
			});
			this._typeahead.getInstance().clear();

		}else{
			swal('Error', error, 'error');
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		if(e.target.name === 'unit_number'){
      			this.getUnitComponent(e.target.name);
      		}
      	}
   	}

	getUnitComponent(type){
		if(this.state[type] !== ""){
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/to_reserve?unit_number='+this.state[type]+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
				method: 'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){					
					this._typeahead.getInstance().clear();
					this._typeahead.getInstance().focus();
					this.setState({components: response});					
				}
			});

		}else{
			swal('Error', 'Debe de ingresar un número de unidad', 'error');
		}
	}

	removeUnit(e, i){
		var units = this.state.units;
		var aux = units.splice(i, i);
		this.setState({units: aux});
	}

	onSave(e){
		e.preventDefault();

		var error = '';
		if(this.state.patient_id === ""){
			error = 'Debe ingresar un paciente';
		}

		if(this.state.units.length === 0){
			error = 'Debe ingresar por lo menos una unidad';
		}

		if(error === ''){
			var obj = {
				patient_id:this.state.patient_id,
				unit_ids:[],
				hf_id:sessionStorage.getItem('health_facilities_id')
			};

			this.state.units.forEach(unit => {
				obj.unit_ids.push(unit.unit.id);
			});

			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'direct_reserves',{
				method:'POST',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg => 
						swal('Error', msg, 'error')	
					);
				}
			}).then(response => {
				if(response !== undefined){
					swal('Correcto', 'Unidad reservada correctamente', 'success');
					this.setState({
						search_type:"",
						nss:"",
						medical_attache:"",
						idee:"",
						options:[],
						isLoading:false,
						list:[],
						patient_name:"",
						patient_lastname1:"",
						patient_lastname2:"",
						patient_sex:"",
						birthdate:"",
						idee:"",
						patient_id:"",
						unit_number:"",
						components:[],
						load:false,
						units:[]
					});
				}
			})
		}else{
			swal('Error', error, 'error');
		}
	}
	
    render(){
        const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

        return (
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Reservas a paciente
					</h5>
				</div>
				
                <Help 
					{...this.props}
	                menu={"help_patients"} 
        			submenu={"direct_reserves"}  
				/>

                <div className='col-xs-12 form-group'>
                    <div className='col-xs-12 form-group'>
                   		 <div className="col-xs-12 col-sm-2">
							<span>Tipo Búsqueda</span>
							<select name="search_type" id="search_type" value={this.state.search_type}
								onChange={this.handleChange} className="form-control">
								<option value="">Seleccione...</option>
								<option value="NSS">NSS</option>
								<option value="IDEE">IDEE</option>
								<option value="local">LOCAL</option>
							</select>
						</div>
						{this.state.search_type === 'NSS' ?
							<div>
								<div className="col-xs-12 col-sm-2">
									<span>NSS</span><span> (*)</span>
									<MaskedFormControl type='text' className="form-control hour-input" name="nss" id="nss" 
										value={ this.state.nss } onChange={ this.handleChange } mask='1111111111' placeholder=""/>					        			
								</div>
								<div className="col-xs-12 col-sm-2">
									<span>Agregado Médico</span>
									<MaskedFormControl type='text' name="medical_attache" id="medical_attache" 
										value={this.state.medical_attache} onChange={this.handleChange} mask='1A1111AA' 
										className="form-control" placeholder=""/>
								</div>
								<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
									<button type="button" className="btn btn-info"
										onClick={this.search_nss}>
										BUSCAR
									</button>
								</div>
							</div>
						:this.state.search_type === 'IDEE' ?
							<div>
								<div className="col-xs-12 col-sm-2">
									<span>IDEE</span><span> (*)</span>
									<input className="form-control" name="idee"
										id="idee" value={this.state.idee} onChange={this.handleChange} />
								</div>
								<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
									<button type="button" className="btn btn-info"
										onClick={this.search_idee}>
										BUSCAR
									</button>
								</div>
							</div>
						:this.state.search_type === 'local' ?
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">{t('content.generics.buttons.search')}</span><span> (*)</span>
								<AsyncTypeahead 
									labelKey={(option) => `${option.names}`}
									minLength={3}
									name="patient"
									id="patient"
									onSearch={this.handleSearch}
									placeholder="Búsqueda por nombre o apellido, HC, o IMSS..."
									options={this.state.options}
									onChange={this.updateState}
									ref={ref => this._typeahead = ref}
									useCache={false}
									isLoading={this.state.isLoading}
									paginationText="Mostrar resultados adicionales"
									emptyLabel="No se encontraron resultados"
									searchText="Buscando..."
									promptText="Ingrese busqueda"
								/>
							</div>
						:null}
                    </div>
					<div className='col-xs-12 form-group'>
						<fieldset>
							<legend>Información del Paciente</legend>
							<div className='col-xs-12'>
								<div className='col-xs-12 col-sm-2 col-md-1'>Nombre del paciente</div>
								<div className='col-xs-12 col-sm-3 col-md-2'>
									{this.state.patient_lastname1+' '+this.state.patient_lastname2+' '+this.state.patient_name}
								</div>
								<div className='col-xs-12 col-sm-2 col-md-1'>Fecha de nacimiento</div>
								<div className='col-xs-12 col-sm-2 col-md-2'>{this.state.birthdate}</div>								
							</div>
							<div className='col-xs-12'>
								<div className='col-xs-12 col-sm-2 col-md-1'>Sexo del paciente</div>
								<div className='col-xs-12 col-sm-3 col-md-2'>{this.state.patient_sex}</div>
								<div className='col-xs-12 col-sm-2 col-md-1'>No. de expediente</div>
								<div className='col-xs-12 col-sm-2 col-md-2'>{this.state.idee}</div>
							</div>
						</fieldset>
					</div>
					<div className='col-xs-12 form-group'>
						<fieldset>
							<legend>Listado de Unidades</legend>
							<div className='col-xs-12 form-group'>
								<div className="col-xs-12 col-sm-1">
									<span className="span-min">No. Unidad</span>
									<input type="text" className="form-control" name="unit_number" id="unit_number"
										value={this.state.unit_number} onChange={this.handleChange} 
										onKeyPress={(e) => this.validateInput(e)} 
									/>
								</div>
								<div className="col-xs-12 reservedHour">
									<span className="span-min">No. Componente</span>									
									<Typeahead
										labelKey={(option) => `${option.label}`}
										minLength={0}
										maxLength={50}
										inputProps={{
											name:"code_component",
											required:'required',
											id:"code_component"
										}}
										id="codeComponent"
										options={this.state.components}
										onChange={this.loadComponent}
										ref={ref => this._typeahead = ref}
										isLoading={this.state.load}
										selectHintOnEnter={true}
										paginationText="Mostrar resultados adicionales"
											emptyLabel="No se encontraron resultados"
											searchText="Buscando..."
											promptText="Ingrese busqueda"
									/>
								</div>
							</div>
							<div className='col-xs-12 form-group'>
								<Table responsive hover>
									<thead>
										<tr>
											<th>No. Unidad</th>
											<th>Componente</th>
											<th>Código Componente</th>
											<th>Volumen</th>
											<th>Fecha Caducidad</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{this.state.units.map((unit, i)=>
											<tr key={i}>
												<td>{unit.unit.unit_number}</td>
												<td>{unit.blood_component.component}</td>
												<td>{unit.blood_component.code}</td>
												<td>{unit.unit.volume}</td>
												<td>{moment(unit.unit.caducidad).format('DD/MM/YYYY HH:mm')}</td>
												<td>
													<button className="btn btn-info btn-xs" title="Eliminar" 
														style={{marginRight:'3px'}} 
														onClick={(e)=>this.removeUnit(e, i)}>
														<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
													</button>
												</td>
											</tr>
										)}
									</tbody>
								</Table>
							</div>
						</fieldset>
					</div>
					<div className='col-xs-12' style={{textAlign:'center'}}>
						<button className='btn btn-info' onClick={(e)=>this.onSave(e)}>Guardar</button>
					</div>
                </div>

                <ModalPatient {...this.props} load={this.loadDataPatient} 
					change={this.handleChange} state={this.state} 
					onRef={ref => this.modal_patient = ref}
					update={this.updateList} />
            </div>
        )
    }
}

export default translate('translations')(DirectReserves);